import auth from "./middleware/auth";
import guest from './middleware/guest'
import statusActive from './middleware/statusActive'

export default [
    {
        path: "",
        name: "home",
        component: require("../components/Home").default,
            meta: {
            middleware: [
                guest
            ]
        },
        
    },
    {
        path: "home",
        name: "home",
        component: require("../components/Home").default,
            meta: {
            middleware: [
                guest
            ]
        },
    },
    {
        path: "login",
        name: "login",
        component: require("../components/Login").default,
           meta: {
            middleware: [
                guest
            ]
        },
    },
    {
        path: "verification",
        name: "verification",
        component: require("../components/Login/Verification").default,
    },
    {
        path: "completeregistration",
        name: "completeregistration",
        component: require("../components/Login/CompleteRegistration").default,
        meta: {
            middleware: [
                auth,
            ]
        },
    },
    {
        path: "completeregistration-notice",
        name: "completeregistration notice",
        component: require("../components/Login/CompleteRegistrationBeforeLogin").default
    },
    {
        path: "reset-password/:token",
        name: "reset-password",
        component: require("../components/ResetPassword").default
    },
    {
        path: "resetpasswordrequest",
        name: "resetpasswordrequest",
        component: require("../components/Login/ResetPasswordRequest").default
    },
    {
        path: "resetpasswordlinksent",
        name: "resetpasswordlinksent",
        component: require("../components/partials/ResetPasswordLinkSent").default
    },
    {
        path: "onboarding",
        name: "onboarding",
        component: require("../components/OnBoarding").default
    },
    {
        path: "dashboard",
        name: "dashboard",
        component: require("../components/Dashboard").default,

        meta: {
            middleware: [
                auth,
                statusActive
            ]
        },
    },
    {
        path: "surveys",
        name: "surveys",
        component: require("../components/Surveys").default,
        meta: {
            middleware: [
                auth,
                statusActive
            ]
        },
    },
    {
        path: "myprofile",
        name: "myprofile",
        component: require("../components/MyProfile").default,
        meta: {
            middleware: [
                auth,
                statusActive
            ]
        },
    },
    {
        path: "unsubscribe",
        name: "unsubscribe",
        component:  require("../components/UnSubscribe").default,
    },
    {
        path: "awards",
        name: "awards",
        component: require("../components/Awards").default,
        meta: {
            middleware: [
                auth,
                statusActive
            ]
        },
    },
    {
        path: "newsevents",
        name: "newsevents",
        component: require("../components/NewsEvents").default,
        meta: {
            middleware: [
                auth,
                statusActive
            ]
        },
    },
    {
        path: "about",
        name: "about",
        component: require("../components/AboutPanel").default,
    },
    {
        path: "terms-and-conditions",
        name: "Terms and conditions",
        component: require("../components/TermsAndConditions").default,

    },
    {
        path: "privacy-policy",
        name: "Privacy Policy",
        component: require("../components/PrivacyPolicy").default,

    },
    {
        path: "cookies",
        name: "Cookies",
        component: require("../components/CookiesPage").default,

    },
    {
        path: "general-conditions-and-rules-of-participation",
        name: "General conditions and rules of participation",
        component: require("../components/AwardPage").default,
    },
    {
        path: "help-and-support",
        name: "help-and-support",
        component: require("../components/HelpAndSupport").default,
    },
    {
        path: "change-email",
        name: "change-email",
        component: require("../components/MyProfile/ChangeEmail").default
    },  
    {
        path: "notification-settings",
        name: "notification-settings",
        component: require("../components/MyProfile/NotificationSettings").default
    }, 
    {
        path: "change-password",
        name: "change-password",
        component: require("../components/MyProfile/ChangePassword").default
    },
    {
        path: "change-password-success",
        name: "change-password-success",
        component: require("../components/MyProfile/ChangePasswordSuccess").default
    },
    {
        path: "edit-profile",
        name: "edit-profile",
        component: require("../components/MyProfile/EditProfile").default
    },
    {
        path: "delete-account/:token",
        name: "delete-acccount",
        component: require("../components/AccountDeletedConfirm").default
    },
    {
        path: "delete-account-success",
        name: "delete-account-success",
        component: require("../components/AccountDeletedSuccess").default
    },
    {
        path: "delete-account-abort",
        name: "delete-account-abort",
        component: require("../components/AccountDeletedAbort").default
    },
    {
        path:"account-delete-verification",
        name:"account-delete-verification",
        component: require("../components/MyProfile/AccountDeleteVerification").default
    },
    {
        path:"account-delete-fail",
        name:"account-delete-fail",
        component: require("../components/AccountDeleteFail").default
    }
];
